import React from "react";
import InputText from "../orders/accepted_orders/InputFilter";
import Container from "../Layout/Container";
import ContentBlock from "../Layout/ContentBlock";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import TableColumnBlacklist from "./items/TableColumnBlacklist";
import ContentValidation from "../common/ContentValidation";
import { SelectForm } from "../common/Buttons";
import PaginationComp from "../Dashboard/items/Pagination";
import { connect } from "react-redux";
import Axios from "axios";
import { message } from "antd";
import {
  buildBulkSelection,
  EMPTY_BULK_SELECTION,
} from "../../hooks/useBulkSelection";
import {
  BulkActionBar,
  BulkHeaderCheckbox,
} from "../common/BulkSelection";

class BlacklistPage extends React.Component {
  constructor() {
    super();
    this.state = {
      page: 1,
      pageCount: 25,
      totals: 0,
      loading: false,
      paramsFilter: "",
      filter: {
        email: "",
        client: "",
        mobile: "",
        shop: [],
      },
      shopOptions: [],
      data: [],
      bulk: EMPTY_BULK_SELECTION,
      bulkLoading: false,
    };
  }

  componentDidMount() {
    this.fetchShopOptions();
    this.reloadData();
  }

  fetchShopOptions = () => {
    Axios.get("/api/v1/order_shops")
      .then((res) => {
        this.setState({ shopOptions: res.data.shops || [] });
      })
      .catch(() => {});
  };

  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount ||
      prevState.paramsFilter !== this.state.paramsFilter
    ) {
      this.reloadData();
    }
  }

  reloadData = () => {
    const { page, pageCount, paramsFilter } = this.state;
    this.setState({ loading: true });

    Axios.get(
      `/api/v1/customers/blacklisted?page=${page}&per_page=${pageCount}${paramsFilter}`
    )
      .then((res) => {
        this.setState({
          data: res.data.data || [],
          totals: res.data.totals || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ data: [], totals: 0, loading: false });
      });
  };

  onFilter = () => {
    const { email, client, mobile, shop } = this.state.filter;
    let filterParams = [];

    if (email.length > 0)
      filterParams.push(`&q[email_i_cont_any]=${encodeURIComponent(email)}`);

    if (client.length > 0) {
      const parts = client.split(" ").filter((item) => item.length > 0);
      parts.forEach((part) => {
        filterParams.push(
          `&q[firstname_or_lastname_cont]=${encodeURIComponent(part)}`
        );
      });
    }

    if (mobile.length > 0) {
      filterParams.push(
        `&q[orders_billing_address_phone_cont]=${encodeURIComponent(mobile)}`
      );
    }

    if (shop.length > 0) {
      shop.forEach((shopId) => {
        filterParams.push(
          `&q[orders_order_shop_id_in][]=${encodeURIComponent(shopId)}`
        );
      });
    }

    this.setState({
      paramsFilter: filterParams.join(""),
      page: 1,
      bulk: EMPTY_BULK_SELECTION,
    });
  };

  filterChange = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value,
      },
    });
  };

  clearFilter = () => {
    this.setState({
      filter: {
        email: "",
        client: "",
        mobile: "",
        shop: [],
      },
      paramsFilter: "",
      page: 1,
      bulk: EMPTY_BULK_SELECTION,
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.onFilter();
    }
  };

  onDelete = (id) => {
    Axios.post(`/api/v1/customers/${id}/remove_from_blacklist`)
      .then(() => this.reloadData())
      .catch(() => {});
  };

  bulkSelection = () =>
    buildBulkSelection(
      this.state.bulk,
      (updater) =>
        this.setState((prev) => ({
          bulk: typeof updater === "function" ? updater(prev.bulk) : updater,
        })),
      this.state.totals
    );

  onBulkRemove = (payload) => {
    this.setState({ bulkLoading: true });
    Axios.post(
      `/api/v1/customers/bulk_remove_from_blacklist?${this.state.paramsFilter.replace(/^&/, "")}`,
      payload
    )
      .then(() => {
        message.success("Removed from blacklist");
        this.setState({ bulk: EMPTY_BULK_SELECTION, bulkLoading: false });
        this.reloadData();
      })
      .catch(() => {
        message.error("Error occurred");
        this.setState({ bulkLoading: false });
      });
  };

  setPagination = (page) => {
    this.setState({ page });
  };

  setPageCount = (pageCount) => {
    this.setState({ pageCount, page: 1 });
  };

  render() {
    const { data, page, pageCount, totals, loading } = this.state;
    const selection = this.bulkSelection();

    return (
      <Container
        location={{
          locationName: "Blacklist",
          locationUrl: this.props.match.url,
        }}
      >
        <>
          <ContentBlock>
            <FilterMenu
                totals={totals}
                length={data.length}
              onChangeCountPage={this.setPageCount}
              countPage={pageCount}
              text2="Blacklist"
            />
          </ContentBlock>
          <ContentBlock>
            <TableFilterBox
              filter={false}
              onFilter={this.onFilter}
              clearFilter={() => this.clearFilter()}
            >
              <div className="px-1">
                <InputText
                  width={"0.75rem"}
                  number="1"
                  name="email"
                  placeholder="Email"
                  onKeyDown={this.handleKeyDown}
                  value={this.state.filter.email}
                  onChange={(e) => this.filterChange(e)}
                />
              </div>
              <div className="px-1">
                <InputText
                  width={"0.75rem"}
                  number="1"
                  name="client"
                  placeholder="Client"
                  onKeyDown={this.handleKeyDown}
                  value={this.state.filter.client}
                  onChange={(e) => this.filterChange(e)}
                />
              </div>
              <div className="px-1">
                <InputText
                  width={"0.75rem"}
                  number="1"
                  name="mobile"
                  placeholder="Mobile"
                  onKeyDown={this.handleKeyDown}
                  value={this.state.filter.mobile}
                  onChange={(e) => this.filterChange(e)}
                />
              </div>
              <div className="px-1" style={{ width: 200 }}>
                <SelectForm
                  mode="multiple"
                  placeholder="Shop"
                  onlyPlaceholder="Choose"
                  options={this.state.shopOptions}
                  value={this.state.filter.shop}
                  onChange={(shop) =>
                    this.setState(
                      {
                        filter: { ...this.state.filter, shop },
                      },
                              this.onFilter
                    )
                  }
                />
              </div>
            </TableFilterBox>
            <BulkActionBar
              selection={selection}
              noun="customers"
              actionText="Remove from blacklist"
              confirmTitle={`Remove ${selection.count} customers from blacklist?`}
              confirmContent="Their blacklist reason will be cleared."
              loading={this.state.bulkLoading}
              onConfirm={this.onBulkRemove}
            />
            <div>
              <ContentValidation
                loader={loading}
                array={data}
                alertId_s="blacklistAlert-s"
                alertId_e="blacklistAlert-e"
              >
                <div className="table-responsive">
                  <table className="table table-sm table-hover mt-3">
                    <thead>
                      <tr className="text-muted">
                        <th style={{ width: 36 }}>
                          <BulkHeaderCheckbox
                            selection={selection}
                            disabled={!totals}
                          />
                        </th>
                        <th className="text-black"></th>
                        <th className="text-black">E-mail</th>
                        <th className="text-black">Name</th>
                        <th className="text-black">Lastname</th>
                        <th className="text-black">Mobile</th>
                        <th className="text-black">Company code</th>
                        <th className="text-black">Date</th>
                        <th className="text-black">Eshop</th>
                        <th className="text-black">Block Reason</th>
                        <th className="text-black">Orders</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <TableColumnBlacklist
                          key={item.id}
                          index={index}
                          item={item}
                          selection={selection}
                          onDelete={this.onDelete}
                        />
                      ))}
                    </tbody>
                  </table>
                  <PaginationComp
                    setPagination={this.setPagination}
                    page={page}
                    totals={totals}
                    pageCount={pageCount}
                  />
                </div>
              </ContentValidation>
            </div>
          </ContentBlock>
        </>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth.user,
});

export default connect(mapStateToProps)(BlacklistPage);
